import React from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { sendOTP, verifyOTP } from "../services/authService";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

const ForgotPassword = () => {
  const { email, setEmail } = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [reg_otp, setOtp] = useState("");

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      toast.error("Email is Required");
      setIsLoading(true);
      sendOTP(email)
        .then((response) => {
          if (response.status === 200) {
            toast.success("OTP Sent");
            setMessage("OTP Sent At Email");
            setIsOpen(true);
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            setMessage("Enter OTP");
            setIsOpen(true);
          } else {
            toast.error("OTP Error");
            setMessage("Error In sending OTP at");
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  function handleverifyOTP(otp) {
    verifyOTP(email, otp)
      .then((response) => {
        toast.success("Success");
        //registerUser();
        closeModal();
      })
      .catch((error) => {
        toast.error("Error");
        console.log(error);
      });
  }

  return (
    <>
      <div className="flex flex-col items-center justify-center px-4 mx-auto h-screen font-pop">
        <div className="w-full bg-red-100 rounded-lg shadow sm:max-w-md">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Forgot Password
            </h1>

            <form
              onSubmit={handleSubmit}
              className="space-y-4 md:space-y-6"
              autoComplete="off"
            >
              <div>
                <label htmlFor="username" className="mr-2 font-bold">
                  Email :
                </label>
                <input
                  type="email"
                  className="input-red"
                  required
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="w-full text-white bg-red-600 hover:bg-red-200 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-2.5 py-2.5 text-center"
              >
                Send Code
              </button>
            </form>
          </div>
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => {} /* Prevent closing when clicking outside */}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center">
                    <Dialog.Title
                      as="h3"
                      className="text-xl font-bold leading-6 text-gray-900 mb-2 font-pop"
                    >
                      OTP sent at <span className="underline">{email}</span>
                    </Dialog.Title>
                    {/* Close Button */}
                    <button
                      type="button"
                      className="text-gray-400 hover:text-gray-600 focus:outline-none"
                      onClick={closeModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>

                  <div>
                    <div>
                      <div className="mb-1 font-pop">
                        <input
                          className="input-red"
                          value={reg_otp}
                          placeholder="Enter OTP"
                          onChange={(e) => setOtp(e.target.value)}
                        ></input>
                      </div>
                    </div>
                    <div className="mt-4 flex justify-center">
                      <button
                        type="button"
                        className="font-pop inline-flex justify-center rounded-md border border-transparent bg-blue-700 px-4 py-2 text-md font-medium text-white hover:bg-blue-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        onClick={(e) => handleverifyOTP(reg_otp)}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ForgotPassword;
